import { CSSResult, html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import styles from './reservation-badges.scss?inline';
import { Messages } from '../../../@types/online-reservation.js';
import { consume } from '@lit/context';
import { i18nContext } from '../i18nContext.js';
import { sharedCss } from '../../../scripts/style/shared.js';

@customElement('reservation-badges')
export class ReservationBadges extends LitElement {
  @property({ type: String, reflect: false })
  private readonly sizeDescription: string = '';

  @property({ type: String, reflect: false })
  private readonly storeLocationName: string = '';

  @property({ type: Boolean })
  private showSizeBadge = true;

  @property({ attribute: false })
  onSizeBadgeClick?: () => void;

  @property({ attribute: false })
  onStoreBadgeClick?: () => void;

  @consume({ context: i18nContext })
  private readonly messages!: Messages;

  static get styles(): CSSResult[] {
    return [sharedCss, unsafeCSS(styles)];
  }

  render() {
    return html`
      <div class="ents-reservation-badges">
        ${this.showSizeBadge ? this.renderSizeBadge() : ''} ${this.storeLocationName ? this.renderStoreBadge() : ''}
      </div>
    `;
  }

  private renderSizeBadge() {
    const content = html`${this.messages.size} <span class="ents-copy-extra-small-bold">${this.sizeDescription}</span>`;

    return this.onSizeBadgeClick
      ? html`
          <button
            type="button"
            class="bdk-badge-system ents-copy-extra-small ents-reservation-badge--clickable"
            variant="neutral"
            size="small"
            data-test-ents-or-size-badge
            @click=${this.onSizeBadgeClick}
          >
            ${content}
          </button>
        `
      : html`
          <div
            class="bdk-badge-system ents-copy-extra-small"
            variant="neutral"
            size="small"
            data-test-ents-or-size-badge
          >
            ${content}
          </div>
        `;
  }

  private renderStoreBadge() {
    const content = html`${this.messages.store}
      <span class="ents-copy-extra-small-bold">${this.storeLocationName}</span>`;

    return this.onStoreBadgeClick
      ? html`
          <button
            type="button"
            class="bdk-badge-system ents-copy-extra-small ents-reservation-badge--clickable"
            variant="neutral"
            size="small"
            data-test-ents-or-store-badge
            @click=${this.onStoreBadgeClick}
          >
            ${content}
          </button>
        `
      : html`
          <div
            class="bdk-badge-system ents-copy-extra-small"
            variant="neutral"
            size="small"
            data-test-ents-or-store-badge
          >
            ${content}
          </div>
        `;
  }
}
